import { createSubscription } from '@24i/nxg-sdk-photon';
import { SubscriptionProductsResponse } from './types';

export const mapSubscriptionProductsResponse = (response: SubscriptionProductsResponse[]) => ({
    subscriptions: response
        .filter((product) => product.type === 'subscription')
        .map(createSubscription),
});
